import React from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Typography from '@mui/material/Typography';
import BottomNavigation from '@mui/material/BottomNavigation';
import TextField from '@mui/material/TextField';
import NttLogo from '../../assets/images/ntt-logo-footer.svg';
import { FOOTER_SUBTITLES } from "../../assets/data/dummyData";

const Footer = () => {
	return (
		<>
			<div className="text-white justify-around items-center lg:py-32 lg:px-16 md:py-16 md:px-8 py-8 px-4" style={{ backgroundColor: "#0059bc" }}>
				<div>
					<div>
						<img
							src={NttLogo}
							component="img"
							alt="NTT DATA Logo"
							height={42}
							width={170}
							className="pb-4"
						/>
						<div className="flex justify-between">
							<div>
								<div className="text-xs md:text-sm lg:text-lg">Lorem ipsum dolor sit amet consectetur. Auctor tempor pretium aliquam neque.</div>
								<div className="pt-12">
									<TextField className="bg-white" size="small" placeholder="Email" />
									<Button size="large"
										style={{
											"background": "#00254F",
											"color": "white",
											textTransform: "none"
										}}
									>Sign Up</Button>
								</div>
							</div>
							<div className="lg:flex lg:space-x-24 lg:justify-start lg:items-start">
								{FOOTER_SUBTITLES.map((title) => (
									<div key={title.id}>
										<Typography className="pb-4" style={{ "fontWeight": "bold" }}>{title.name}</Typography>
										{title.subtitles.map((subtitle) => (
											<div className="hidden md:hidden lg:block">
												<Typography key={subtitle.id}>{subtitle.name}</Typography>
											</div>
										))}
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			<Divider className="text-white" />
			<AppBar position="static">
				<BottomNavigation style={{
					"backgroundColor": "#0059BC",
					color: "white",
					"justifyContent": "space-around",
					"alignItems": "center",
				}}>
					<Typography>contact@nttdata.com</Typography>
					<Typography>+3 9876 765 444</Typography>
					<div className="hidden md:block lg:block">
						<IconButton><InstagramIcon className="text-white" /></IconButton>
						<IconButton><FacebookIcon className="text-white" /></IconButton>
						<IconButton><LinkedInIcon className="text-white" /></IconButton>
					</div>
				</BottomNavigation>
			</AppBar>
		</>

	);
};

export default Footer;